import WorkOrderCard from './WorkOrderCard';

export default WorkOrderCard;
